const logger = (...messages) => {
    if (process.env.NODE_ENV === 'development') {
        if (messages.length === 1) {
            messages = messages[0];
        }
        console.log(messages);
    }
}
export default logger;